class Drawer extends HTMLElement {
  connectedCallback() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('[id*=-Overlay]').addEventListener('click', this.close.bind(this));
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      document.querySelector('mobile-menu')?.mobilemenuHide();
      document.body.classList.add('drawer--isActive');
      this.classList.add('animate', 'active');
    });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : this.firstElementChild;
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    setTimeout(() => {
      document.body.classList.remove('drawer--isActive');
    }, 300);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

class DrawerButton extends Drawer {
  drawerTag = null;
  drawer = null;
  drawerQuickAddId = null;

  connectedCallback() {
    this.drawerTag = this.dataset.drawerTag;
    this.drawerQuickAddId = this.dataset.quickAddId;

    if (!this.drawerTag) {
      return;
    }

    if (this.drawerQuickAddId) {
      this.drawer = document.querySelector(`${this.drawerTag}[data-quick-add-id="${this.drawerQuickAddId}"]`);
    } else {
      this.drawer = document.querySelector(this.drawerTag);
    }

    if (!this.drawer) {
      return;
    }

    this.addEventListener('click', (e) => {
      this.handleClick(e);
    });
  }

  handleClick(e) {
    let action = (this.dataset.action) ? this.dataset.action : 'open';
    if (action === 'open') {
      if(e.target.classList.contains('quick-add-drawer-button')) {
        if(document.querySelector('#CartDrawer free-shipping')) document.querySelector('#CartDrawer free-shipping').style.zIndex = 0;
      }
      this.drawer.open();
      const selectProductId = this.dataset.selectProductId;
      if (selectProductId) {
        const card = this.drawer.querySelector('product-card');
        if (card && typeof card.selectColourway === 'function') {
          card.selectColourway(selectProductId);
        }
      }
    } else {
      this.drawer.close();
    }
  }
}

customElements.define('drawer-button', DrawerButton);
